// @flow

import { type OpenedIncomingPayment } from './types';
import { type Ui } from '@tectonics/prs/ui';

export function getSafeUi(incomingPayment: OpenedIncomingPayment): Ui {
  const ui = incomingPayment['ui'];
  if (!ui) {
    throw new Error('getSafeUi - there is no UI node in the incoming payment');
  }
  return ui;
}
